import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(app)/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"cyrillic\"],\"weight\":\"400\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/src/entities/store/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/styles/global.scss");
